var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgService = function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#service_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.163 6.098v6.098c-1.726 0-3.122-1.36-3.098-3.037 0-1.15.637-2.143 1.592-2.67C3.992 2.72 7.653 0 11.976 0c4.31 0 7.97 2.706 9.318 6.49.943.526 1.592 1.53 1.592 2.67 0 1.677-1.396 3.048-3.123 3.048v-6.11c.086 0 .172 0 .257.012-1.383-3-4.469-5.094-8.057-5.094-3.587 0-6.673 2.094-8.057 5.094.086-.012.172-.012.257-.012ZM22.69 22.751c-.343-2.339-1.678-4.273-3.845-5.571a11.131 11.131 0 0 1-6.882 2.338c-2.51 0-4.91-.82-6.87-2.338-1.101.673-1.983 1.506-2.632 2.485-.612.919-.992 1.96-1.15 3.086H22.69Zm-10.727-4.457c2.596 0 4.972-.98 6.735-2.596C21.894 17.29 24 20.118 24 23.975H0c0-3.844 2.07-6.673 5.229-8.277a9.942 9.942 0 0 0 6.734 2.596Zm5.535-8.633c0-2.975-2.486-5.388-5.535-5.388S6.43 6.698 6.43 9.661c0 2.976 2.485 5.388 5.534 5.388 3.05 0 5.535-2.412 5.535-5.388Zm-12.294 0c0-3.649 3.025-6.612 6.76-6.612 3.722 0 6.746 2.963 6.758 6.612 0 3.65-3.024 6.612-6.759 6.612-3.734 0-6.759-2.963-6.759-6.612Z",
    fill: "#018DD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "service_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgService;